<template>
  <v-select
    :value="value"
    dense
    :items="contactFilters"
    :menu-props="{maxHeight: '80%'}"
    return-object
    :error-messages="errorMessages"
    v-bind="$attrs"
    @click:append-outer="clickAppendOuter"
    @input="input"
  >
    <template
      v-if="allowEdit"
      #append-item
    >
      <v-divider
        v-if="contactFilters.length > 0"
        class="mt-0"
      />
      <!-- add  -->
      <v-list-item @click="add">
        <v-list-item-icon
          color="grey lighten-3"
          class="mr-0 pr-0"
        >
          <v-icon small>
            mdi-plus
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $t('label.add_new_filter') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- duplicate  -->
      <v-list-item
        v-if="isFilter"
        @click="duplicate"
      >
        <v-list-item-icon
          color="grey lighten-3"
          class="mr-0 pr-0"
        >
          <v-icon small>
            mdi-content-duplicate
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $t('label.duplicate_current_filter') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- edit  -->
      <v-list-item
        v-if="canEditFilter"
        @click="edit"
      >
        <v-list-item-icon
          color="grey lighten-3"
          class="mr-0 pr-0"
        >
          <v-icon small>
            mdi-pencil
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>
            {{ $t('label.edit_current_filter') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script setup lang="ts">
import ContactFilter from '@/grpc-api/model/contact-filter';
import { computed, PropType } from 'vue';
import { TranslateResult } from 'vue-i18n';

const props = defineProps({
  filters: { type: Array as PropType<Array<ContactFilter>>, required: true },
  value: { type: Object as PropType<undefined|null|ContactFilter>, required: true },
  allowEdit: { type: Boolean as PropType<boolean>, required: false, default: false },
  errorMessages: { type: Array as PropType<Array<String>>, required: false, default: () => [] },
});

const isFilter = computed(() => props.value !== null && props.value !== undefined);

const canEditFilter = computed(() => props.value?.isDefault === false);

const defaultFilters = computed(() => props.filters.filter((f) => f.isDefault === true));

const customFilters = computed(() => props.filters.filter((f) => f.isDefault === false));

const contactFilters = computed(() => {
  const noDevider = defaultFilters.value.length === 0 || customFilters.value.length === 0;
  if (noDevider) return [...defaultFilters.value, ...customFilters.value];
  return [
    ...defaultFilters.value,
    { divider: true },
    ...customFilters.value,
  ];
});

const emit = defineEmits(['input', 'add-filter', 'edit-filter', 'duplicate-filter', 'click:append-outer']);

const input = (value: ContactFilter) => {
  emit('input', value);
};

const add = () => {
  emit('add-filter');
};

const edit = () => {
  emit('edit-filter');
};

const duplicate = () => {
  emit('duplicate-filter');
};

const clickAppendOuter = () => {
  emit('click:append-outer');
};

</script>
